export default {
    label_task:{
        en:"Incentive Slabs",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Slab",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Slab",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details Slab",
        bn:'ব্যবহারকারীর বিবরণ'
    },
}